"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

//     NoFlo - Flow-Based Programming for JavaScript
//     (c) 2013-2020 Flowhub UG
//     (c) 2011-2012 Henri Bergius, Nemein
//     NoFlo may be freely distributed under the MIT license

/* eslint-disable no-underscore-dangle */
var debug = require('debug')('noflo:component');

var IP = require('./IP'); // Checks if a value is an Error


function isError(err) {
  return err instanceof Error || Array.isArray(err) && err.length > 0 && err[0] instanceof Error;
}

module.exports = /*#__PURE__*/function () {
  function ProcessOutput(ports, context) {
    _classCallCheck(this, ProcessOutput);

    this.ports = ports;
    this.context = context;
    this.nodeInstance = this.context.nodeInstance;
    this.ip = this.context.ip;
    this.result = this.context.result;
    this.scope = this.context.scope;
  } // Sends an error object


  _createClass(ProcessOutput, [{
    key: "error",
    value: function error(err) {
      var _this = this;

      var errs = err;
      var multiple = Array.isArray(err);

      if (!multiple) {
        errs = [err];
      }

      if ('error' in this.ports && (this.ports.error.isAttached() || !this.ports.error.isRequired())) {
        if (multiple) {
          this.sendIP('error', new IP('openBracket'));
        }

        errs.forEach(function (e) {
          _this.sendIP('error', e);
        });

        if (multiple) {
          this.sendIP('error', new IP('closeBracket'));
        }
      } else {
        errs.forEach(function (e) {
          throw e;
        });
      }
    } // Sends a single IP object to a port

  }, {
    key: "sendIP",
    value: function sendIP(port, packet) {
      var ip;

      if (!IP.isIP(packet)) {
        ip = new IP('data', packet);
      } else {
        ip = packet;
      }

      if (this.scope !== null && ip.scope === null) {
        ip.scope = this.scope;
      }

      if (!this.nodeInstance.outPorts[port]) {
        throw new Error("Node ".concat(this.nodeInstance.nodeId, " does not have outport ").concat(port));
      }

      if (this.nodeInstance.outPorts[port].isAddressable() && ip.index === null) {
        throw new Error("Sending packets to addressable port ".concat(this.nodeInstance.nodeId, " ").concat(port, " requires specifying index"));
      }

      if (this.nodeInstance.isOrdered()) {
        this.nodeInstance.addToResult(this.result, port, ip);
        return;
      }

      if (!this.nodeInstance.outPorts[port].options.scoped) {
        ip.scope = null;
      }

      this.nodeInstance.outPorts[port].sendIP(ip);
    } // Sends packets for each port as a key in the map
    // or sends Error or a list of Errors if passed such

  }, {
    key: "send",
    value: function send(outputMap) {
      var _this2 = this;

      if (isError(outputMap)) {
        this.error(outputMap);
        return;
      }

      var componentPorts = [];
      var mapIsInPorts = false;
      Object.keys(this.ports.ports).forEach(function (port) {
        if (port !== 'error' && port !== 'ports' && port !== '_callbacks') {
          componentPorts.push(port);
        }

        if (!mapIsInPorts && outputMap != null && _typeof(outputMap) === 'object' && Object.keys(outputMap).indexOf(port) !== -1) {
          mapIsInPorts = true;
        }
      });

      if (componentPorts.length === 1 && !mapIsInPorts) {
        this.sendIP(componentPorts[0], outputMap);
        return;
      }

      if (componentPorts.length > 1 && !mapIsInPorts) {
        throw new Error('Port must be specified for sending output');
      }

      Object.keys(outputMap).forEach(function (port) {
        var packet = outputMap[port];

        _this2.sendIP(port, packet);
      });
    } // Sends the argument via `send()` and marks activation as `done()`

  }, {
    key: "sendDone",
    value: function sendDone(outputMap) {
      this.send(outputMap);
      this.done();
    } // Makes a map-style component pass a result value to `out`
    // keeping all IP metadata received from `in`,
    // or modifying it if `options` is provided

  }, {
    key: "pass",
    value: function pass(data) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (!('out' in this.ports)) {
        throw new Error('output.pass() requires port "out" to be present');
      }

      var that = this;
      Object.keys(options).forEach(function (key) {
        var val = options[key];
        that.ip[key] = val;
      });
      this.ip.data = data;
      this.sendIP('out', this.ip);
      this.done();
    } // Finishes process activation gracefully

  }, {
    key: "done",
    value: function done(error) {
      var _this3 = this;

      this.result.__resolved = true;
      this.nodeInstance.activate(this.context);

      if (error) {
        this.error(error);
      }

      var isLast = function isLast() {
        // We only care about real output sets with processing data
        var resultsOnly = _this3.nodeInstance.outputQ.filter(function (q) {
          if (!q.__resolved) {
            return true;
          }

          if (Object.keys(q).length === 2 && q.__bracketClosingAfter) {
            return false;
          }

          return true;
        });

        var pos = resultsOnly.indexOf(_this3.result);
        var len = resultsOnly.length;
        var load = _this3.nodeInstance.load;

        if (pos === len - 1) {
          return true;
        }

        if (pos === -1 && load === len + 1) {
          return true;
        }

        if (len <= 1 && load === 1) {
          return true;
        }

        return false;
      };

      if (this.nodeInstance.isOrdered() && isLast()) {
        // We're doing bracket forwarding. See if there are
        // dangling closeBrackets in buffer since we're the
        // last running process function.
        Object.keys(this.nodeInstance.bracketContext["in"]).forEach(function (port) {
          var contexts = _this3.nodeInstance.bracketContext["in"][port];

          if (!contexts[_this3.scope]) {
            return;
          }

          var nodeContext = contexts[_this3.scope];

          if (!nodeContext.length) {
            return;
          }

          var context = nodeContext[nodeContext.length - 1];
          var inPorts = _this3.nodeInstance.inPorts[context.source];
          var buf = inPorts.getBuffer(context.ip.scope, context.ip.index);

          while (buf.length > 0 && buf[0].type === 'closeBracket') {
            var ip = inPorts.get(context.ip.scope, context.ip.index);
            var ctx = nodeContext.pop();
            ctx.closeIp = ip;

            if (!_this3.result.__bracketClosingAfter) {
              _this3.result.__bracketClosingAfter = [];
            }

            _this3.result.__bracketClosingAfter.push(ctx);
          }
        });
      }

      debug("".concat(this.nodeInstance.nodeId, " finished processing ").concat(this.nodeInstance.load));
      this.nodeInstance.deactivate(this.context);
    }
  }]);

  return ProcessOutput;
}();